<template>
  <div class="app-content content bg-full-screen-image ">
    <div class="content-overlay"></div>
    <div class="content-wrapper">
      <div class="content-header row">
      </div>
      <div class="content-body">
        <!-- login page start -->
        <section id="auth-login" class="row flexbox-container">
          <div class="col-xl-8 col-11">
            <div class="card bg-authentication mb-0">
              <div class="row m-0">
                <!-- left section-login -->
                <div class="col-md-6 col-12 px-0">
                  <div class="card disable-rounded-right mb-0 p-2 h-100 d-flex justify-content-center">
                    <div class="card-header pb-1">
                      <div class="card-title">
                        <h4 class="text-center mb-2"><span class="text-danger">METREKÜP</span> Mimarlik İnşaat </h4>
                      </div>
                    </div>
                    <div class="card-body">
                      <form id="login-form" @submit.stop.prevent="onSubmit">
                        <div role="alert" v-bind:class="{ show: errors }" class="alert fade alert-danger">
                          <div class="alert-text">
                            {{ errors }}
                          </div>
                        </div>

                        <b-form-group
                            id="fieldset-1"
                            class="form-group mb-50"
                            :label="$t('login.email')"
                            label-for="email"
                            label-class="text-bold-600"
                            :state="validateState('email')"
                        >
                          <b-form-input type="email"
                                        id="email"
                                        v-model="form.email"
                                        :state="validateState('email')"
                                        :placeholder="$t('login.email')" trim>
                          </b-form-input>

                          <b-form-invalid-feedback
                              v-if="!validateState('email') && !$v.form.email.required"
                              :state="!(validateState('email') && !$v.form.email.required)">
                            {{ $t('login.validations.email.required') }}
                          </b-form-invalid-feedback>

                          <b-form-invalid-feedback v-if="!validateState('email') && !$v.form.email.email"
                                                   :state="!(validateState('email') && !$v.form.email.email)">
                            {{ $t('login.validations.email.email') }}
                          </b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group
                            id="password-form-group"
                            class="form-group mb-50"
                            :label="$t('login.password')"
                            label-for="email"
                            label-class="text-bold-600"
                            :state="validateState('password')"
                        >
                          <b-form-input type="password"
                                        id="password"
                                        v-model="form.password"
                                        :state="validateState('password')"
                                        :placeholder="$t('login.password')" trim>
                          </b-form-input>
                          <b-form-invalid-feedback
                              v-if="!validateState('password') && !$v.form.password.required"
                              :state="!(validateState('password') && !$v.form.email.required)">
                            {{ $t('login.validations.password.required') }}
                          </b-form-invalid-feedback>
                        </b-form-group>

                        <div class="form-group d-flex flex-md-row flex-column justify-content-between align-items-center">
                          <div class="text-right">
                            <a @click="$router.push({ name: 'forgot_password' })" class="card-link">
                              <small>{{ $t("login.forgot_password") }}</small>
                            </a>
                          </div>
                        </div>
                        <button :disabled="loading" type="submit" class="btn btn-primary glow w-100 position-relative">
                          {{ $t('login.send') }}
                          <i id="icon-arrow" class="bx bx-right-arrow-alt"></i>
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
                <!-- right section image -->
                <div class="col-md-6 d-md-block d-none text-center align-self-center p-3">
                  <img class="img-fluid" :src="backgroundImage" alt="branding logo">
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- login page ends -->

      </div>
    </div>
  </div>

</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "~@/assets/sass/pages/authentication.scss";

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
import { mapState } from "vuex";
import { LOGIN, LOGOUT } from "@/core/services/store/auth.module";
import moduleUser, {
  MODULE_NAME as MODULE_USER,
  GET_SELF
} from "@/core/services/store/user.module";
import { validationMixin } from "vuelidate";
import { email, required } from "vuelidate/lib/validators";
import store from "@/core/services/store";

import { head, values } from "lodash/fp";

const _MODULE_USER = MODULE_USER;

export default {
  name: "Login",
  mixins: [validationMixin],
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_USER, moduleUser);
  },
  data() {
    return {
      loading: false,
      form: {
        email: "",
        password: ""
      }
    };
  },
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required
      }
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
    backgroundImage() {
      return process.env.BASE_URL + "media/pages/login.png";
    }
  },
  methods: {
    validateState(name) {
      const {$dirty, $error} = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      let self = this;
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      const email = this.form.email;
      const password = this.form.password;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      this.loading = true;

      // send login request
      this.$store
        .dispatch(LOGIN, { email, password })
        // go to which page after successfully login
        .then(() => {
          self.$store.dispatch(_MODULE_USER + "/" + GET_SELF).then(res => {
            if (res) {
              self.loading = false;
              let firstItem = _.first(head(values(res.menu)));
              if (firstItem) {
                this.$router.push({ path: firstItem.link });
              } else {
                this.$router.push({ name: "dashboard" });
              }

              setTimeout(() => {
                window.location.reload();
              }, 500);
            }
          });
        });

      self.loading = false;
    }
  },
  mounted() {
    document.body.classList.add('light-layout', '1-column', 'navbar-sticky',
        'footer-static', 'bg-full-screen-image', 'blank-page', 'pace-done')
  }
};
</script>

<style scoped>
.btn {
  color: #fff !important;
}
</style>
